module.exports = __webpack_public_path__ + "img/995555.efb65f8d.jpg";